module.exports = __webpack_public_path__ + "static/media/Timetable-01.12aa4f0f.svg";